import styled from "styled-components";

export const RichTextEditorStyled = styled.div`
  width: 100%;

  .ql-container {
    font-family: Inter, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-color: #080425 !important;
    min-height: 120px;
  }

  .ql-toolbar {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-color: #080425 !important;
    display: ${(props) => (props.isReadOnly ? "none" : "block")};
  }

  .ql-editor {
    min-height: 120px;
    cursor: ${(props) => (props.isReadOnly ? "default" : "text")};

    &.ql-blank::before {
      color: #9e9e9e;
      font-style: normal;
    }

    p,
    li {
      font-family: Inter, sans-serif;
    }
  }

  &.ql-disabled .ql-editor,
  .ql-editor[contenteditable="false"] {
    background-color: transparent;
  }
`;
